import React from 'react';
import { Gift, ShieldAlert, ShoppingCart, Coffee } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
const bonuses = [{
  id: 1,
  title: 'Botón de Pánico',
  desc: 'Protocolo de alivio en 30 minutos para cuando el dolor toma el control. Tu guía de rescate para la crisis.',
  icon: ShieldAlert
}, {
  id: 2,
  title: 'Calculadora de Alacena Argentina',
  desc: 'Qué comprar y qué dejar en la góndola. Decisiones de supermercado en 10 segundos.',
  icon: ShoppingCart
}, {
  id: 3,
  title: 'Guía de Infusiones de Herboristería Local',
  desc: '12 recetas exactas con plantas que conseguís en cualquier herboristería argentina.',
  icon: Coffee
}];
export function BonusSection() {
  const ref = useScrollReveal();
  const scrollToBuy = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('elegir-plan')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-petroleo py-16 px-5 flex justify-center" data-id="element-15">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col gap-8" data-id="element-16">
        <div className="flex flex-col gap-4 text-center" data-id="element-17">
          <div className="inline-flex items-center justify-center gap-2 bg-salvia/20 text-salvia-light px-4 py-1.5 rounded-full text-sm font-semibold self-center border border-salvia/30" data-id="element-18">
            <Gift className="w-4 h-4" data-id="element-19" />
            GRATIS por el día de hoy
          </div>
          <h2 className="font-serif font-bold text-white text-3xl leading-tight" data-id="element-20">
            Además, incluye 3 Bonus que valen más que el protocolo.
          </h2>
        </div>
        <div className="flex flex-col gap-4" data-id="element-21">
          {bonuses.map(bonus => <div key={bonus.id} onClick={scrollToBuy} className="bg-white rounded-2xl p-5 shadow-lg cursor-pointer active:scale-[0.98] transition-transform flex gap-4 items-start" data-id="element-22">
              <div className="bg-blush-light p-3 rounded-xl flex-shrink-0" data-id="element-23">
                <bonus.icon className="w-6 h-6 text-petroleo" data-id="element-24" />
              </div>
              <div className="flex flex-col gap-1" data-id="element-25">
                <p className="text-xs font-bold text-salvia uppercase tracking-wider" data-id="element-26">
                  Bonus {bonus.id}
                </p>
                <h3 className="font-serif font-bold text-petroleo text-lg leading-tight" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm leading-snug mt-1" data-id="element-28">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}